export const auctionLotsSelector = ({ auction: { lots } }) => lots;


export const allAuctionsSelector = ({ auction: { allAuctions } }) => allAuctions;


export const auctionDateSelector = ({ auction: { date } }) => date;


